import styled from "styled-components"

const OptionsContainer = styled.div``

export default OptionsContainer